<template>
  <Toast />
  <Header />
  <router-view></router-view>
  <Footer />
</template>

<script>
import Toast from '@components/toast/Toast.vue'
import Header from '@components/navigation/header/index.vue'
import Footer from '@components/navigation/footer/index.vue'

export default {
  name: 'App',
  components: { Toast, Header, Footer },
  setup() {},
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
@import '@/assets/variables.scss';
@import '@/assets/classes.scss';
@import '@/assets/media.scss';
@import '@/assets/transition.scss';

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
}

#app {
  width: 100%;
  margin: 0;
  color: var(--dark-10);
  overflow-x: hidden;
}
</style>
